import "./pull-to-refresh.css";
import { PullToRefresh } from './pull-to-refresh';
export default PullToRefresh;